import { render, staticRenderFns } from "./ProdutosFornecedor.vue?vue&type=template&id=3d5ee58d&scoped=true&"
import script from "./ProdutosFornecedor.vue?vue&type=script&lang=js&"
export * from "./ProdutosFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ee58d",
  null
  
)

export default component.exports